import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getGradeFields } from "../../../services/Settings/dropdown"
import {
  manufacturingJournalLi,
  searchManufacturingJournal,
} from "../../../services/finance/finance"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const ManufactureLi = ({
  control,
  name,
  onSelectChange,
  disabled,
  placeholder,
  projectId,
  statusChk,
  grandTotal,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [gradeData, setGradeData] = useState([])

  const loadOptions = async () => {
    const data = await manufacturingJournalLi({
      params: `${projectId ? `project_id=${projectId}` : ""}${
        statusChk ? `&status=${statusChk}` : ""
      }`,
    })
    setIsLoading(false)
    // const grade_id = data?.data?.map(dta => {
    //   return {
    //     label:
    //       dta?.code &&
    //       `${ucfirst(dta?.code)} ${
    //         grandTotal
    //           ? `- (${(
    //               Number(dta?.grand_with_total) -
    //               Number(dta?.partialsale_sum_amount || 0)
    //             ).toFixed(2)} AED)`
    //           : ""
    //       }`,
    //     value: dta.id,
    //     ...dta,
    //   }
    // })

    const grade_id = data?.data
      ?.filter(
        dta =>
          Number(dta?.grand_with_total) -
            Number(dta?.partialsale_sum_amount || 0) >
          0
      )
      .map(dta => {
        return {
          label: dta?.code && ucfirst(dta.code),
          value: dta.id,
          ...dta,
        };
      });
    
      // .map(dta => {
      //   return {
      //     label:
      //       dta?.code &&
      //       `${ucfirst(dta?.code)} ${
      //         grandTotal
      //           ? `- (${(
      //               Number(dta?.grand_with_total) -
      //               Number(dta?.partialsale_sum_amount || 0)
      //             ).toFixed(2)} AED)`
      //           : ""
      //       }`,
      //     value: dta.id,
      //     ...dta,
      //   }
      // })

    setGradeData(grade_id)
  }

  useEffect(() => {
    loadOptions()
  }, [projectId])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={gradeData}
              // placeholder={placeholder ? placeholder : "Grade"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Grade"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              isDisabled={disabled}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              // menuPortalTarget={document.querySelector(".modal")}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          )
        }}
      />
    </div>
  )
}

export default ManufactureLi
